<template>
  <div class="list-menu-without-profile__container">
    <v-list-tile
      :name="item.name"
      :color="item.active ? item.color : ''"
      v-for="(item, index) in itemDefault"
      v-show="!item.hidden"
      :key="index"
      :class="darkTheme ? 'item-menu-without-active-dark' : 'item-menu-without-active-light'"
      :style="{
        width: '100% !important',
        display: 'flex',
        justifyContent: mini ? 'center' : 'stretch'
      }"
    >
      <div
        :style="{
          width: '100%',
          display: 'flex',
          gap: 4,
          justifyContent: mini ? 'center' : 'stretch'
        }"
      >
        <v-tooltip right>
          <template v-slot:activator="{ on }">
            <v-list-tile-action>
              <v-badge
                class="notification-badge"
                color="accent"
                v-if="unreadMessage > 0 && item.route === '/info'"
                right
              >
                <span slot="badge">{{ unreadMessage }}</span>
                <v-icon>{{ item.icon }}</v-icon>
              </v-badge>
              <v-icon
                v-on="on"
                v-else
                :class="item.iconClass"
                :color="item.active ? item.color : ''"
                >{{ item.icon }}</v-icon
              >
            </v-list-tile-action>
          </template>
          <span>{{ item.name }}</span>
        </v-tooltip>
        <v-list-tile-content>
          <v-list-tile-title>{{ $t(item.title) }}</v-list-tile-title>
        </v-list-tile-content>
      </div>
    </v-list-tile>
    <v-list-tile
      :class="darkTheme ? 'btn-login-dark' : 'btn-login'"
      :title="$t('page.sign_in')"
      @click="changeNavicationRouteItem($event, { route: '/sign-in', name: 'sign-in' })"
      :style="{
        display: 'flex',
        justifyContent: mini ? 'center' : 'stretch',
        width: '100%'
      }"
    >
      <v-list-tile-action v-if="mini">
        <v-icon>arrow_forward</v-icon>
      </v-list-tile-action>
      <div
        v-else
        :style="{
          display: 'flex',
          gap: 4,
          justifyContent: mini ? 'center' : 'stretch',
          width: '100%'
        }"
      >
        <v-list-tile-action>
          <v-icon>arrow_forward</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>{{ $t('page.sign_in') }}</v-list-tile-title>
        </v-list-tile-content>
      </div>
    </v-list-tile>
  </div>
</template>
<script>
export default {
  name: 'ListMenuItemWithoutProfile',
  props: {
    mini: {
      type: Boolean
    },
    onChangeRoute: {
      type: Function
    }
  },
  data() {
    return {
      itemDefault: [
        {
          icon: 'bookmark',
          title: 'page.booking',
          route: '/records',
          color: '#0050B3',
          name: 'records'
        },
        {
          icon: 'dashboard',
          title: 'page.dashboards',
          route: '/dashboards',
          color: '#0050B3',
          name: 'dashboards'
        },

        {
          icon: 'event_available',
          title: 'page.verify_order',
          route: '/verify-order',
          color: '#0050B3',
          name: 'verify_order',
          hidden:
            !this.$store.getters.userProfile ||
            !this.$store.getters.userProfile.partner ||
            this.$constants.NEED_CONFIRM_PICKUP_PARTNERS.indexOf(
              this.$store.getters.userProfile.partner
            ) == -1
        },
        {
          icon: 'people',
          title: 'page.employees',
          route: '/employees',
          color: 'accent',
          name: 'employees'
        }
      ]
    }
  },
  methods: {
    changeNavicationRouteItem($event, item) {
      this.$emit('onChangeRoute', $event, item)
    }
  },
  computed: {
    darkTheme() {
      const theme = this.$store.getters.theme
      if (!theme) return false
      return theme
    }
  }
}
</script>
<style scoped lang="scss">
.list-menu-without-profile__container {
  .item-menu-without-active-dark {
    &:hover {
      background-color: rgba(230, 233, 236, 0.11) !important;
      border-radius: 6px;
      cursor: pointer;
    }
  }

  .item-menu-without-active-light {
    &:hover {
      background-color: #e6e9ec;
      border-radius: 6px;
      cursor: pointer;
    }
  }

  .btn-login-dark {
    &:hover {
      background-color: rgba(230, 233, 236, 0.11);
      border-radius: 6px;
      cursor: pointer;
    }
  }

  .btn-login {
    &:hover {
      background-color: #e6e9ec;
      border-radius: 6px;
      cursor: pointer;
    }
  }
}

.v-list__tile__action {
  min-width: 40px;
}

.v-tooltip__content {
  margin-left: 10px !important;
}
</style>
